export const frontmatter = {
    "draft": false,
    "title": "Organizaciones",
    "description": "Gestión de organizaciones en OnnIA.",
    "sidebar_label": "Organizaciones",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []